import axios from 'axios';

const ROOT = 'api/v1/patients';

const PatientApi = {
  exportPatients(filterProperty) {
    return axios.post(`${ROOT}/download`, filterProperty, {
      responseType: 'arraybuffer'
    });
  },
  getSearchPatients(page, pageSize, searchString) {
    return axios.post(
      `${ROOT}/search`,
      { page, pageSize, searchString },
      {
        hideLoader: true
      }
    );
  },
  getSearchPatientProfiles(page, pageSize, searchString) {
    return axios.post(
      `${ROOT}/search-patients-profiles`,
      { page, pageSize, searchString },
      {
        hideLoader: true
      }
    );
  },
  getRecentPatients(page, pageSize) {
    return axios.post(
      `${ROOT}/recent-patients`,
      { page, pageSize },
      {
        hideLoader: true
      }
    );
  },
  getRecentPatientsProfiles(page, pageSize) {
    return axios.post(
      `${ROOT}/recent-patients-profiles`,
      { page, pageSize },
      {
        hideLoader: true
      }
    );
  },
  updateSubjectId(ssuPatientId, subjectId) {
    return axios.put(`${ROOT}/${ssuPatientId}/subject-id`, { subjectId });
  },
  updatePatientSourceId(ssuPatientId, data) {
    return axios.put(`${ROOT}/${ssuPatientId}/patient-source-id`, data);
  },

  checkSubjectIdInCurrentStudy(ssuPatientId, resolvedSubjectId) {
    return axios.post(`${ROOT}/${ssuPatientId}/check-duplicate-subject-id`, { subjectId: resolvedSubjectId });
  },
  checkAbilityToEditFinanceDetails(patientId) {
    return axios.get(`${ROOT}/${patientId}/patient-payment-access`);
  },
  checkAbilityToAddFinanceDetails(studySiteId) {
    return axios.get(`${ROOT}/study-sites/${studySiteId}/patient-payment-access`);
  },
  getDictionaries() {
    return axios.get(`${ROOT}/dictionaries`);
  }
};

export default PatientApi;
